<ng-container *ngIf="column.searchable">
  <div class="filter-title-mobile">
    <mat-label>{{column.label | translate}}</mat-label>
  </div>

  <div [ngSwitch]="column.type">
    <div *ngSwitchCase="type.TEXT_COLUMN">
      <nc-text-filter [filterName]="column.filterName" [formGroup]="formGroup"></nc-text-filter>
    </div>
    <div *ngSwitchCase="type.SELECT_COLUMN">
      <nc-select-filter [column]="column" [formGroup]="formGroup"></nc-select-filter>
    </div>
    <div *ngSwitchCase="type.DATE_COLUMN" class="date-range-picker">
      <nc-date-filter [column]="column" [formGroup]="formGroup"></nc-date-filter>
    </div>
  </div>
</ng-container>
